import React, {ComponentType, ReactNode} from 'react';

import {withRouter, WithRouterProps} from 'react-router';

import {reportToSentry} from 'app/utils/sentry';

interface Props extends WithRouterProps {
  name: string;
  children?: ReactNode;
  ErrorComponent?: string | ComponentType<Record<string, never>>;
}

type State = {
  hasError: boolean;
};

class BaseErrorBoundary extends React.Component<Props, State> {
  state = {
    hasError: false,
  };

  componentDidCatch(error: any, info: any) {
    this.setState({
      hasError: true,
    });
    reportToSentry(
      error,
      {
        info,
        errorBoundaryname: this.props.name,
      },
      true
    );
  }

  static getDerivedStateFromError() {
    return {hasError: true};
  }

  UNSAFE_componentWillReceiveProps(nextProps: Props) {
    const {location} = this.props;

    if (nextProps.location != null && location != null) {
      if (location.pathname !== nextProps.location.pathname) {
        this.setState({
          hasError: false,
        });
      }
    }
  }

  render() {
    const {children, ErrorComponent} = this.props;
    const {hasError} = this.state;

    if (hasError) {
      return ErrorComponent != null ? <ErrorComponent /> : null;
    }

    return children != null ? children : null;
  }
}

export const ErrorBoundary = withRouter(BaseErrorBoundary);
